import React, { PropTypes } from 'react';

import GrayPanel from '../../components/GrayPanel/GrayPanel';
import ModalAlert from '../../components/ModalAlert/ModalAlert';
import { runService } from '../../actions/eservices';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';

import Select from 'react-select';
import { throws } from 'assert';
import pans from './panStyle.scss';

import v from './validators';

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};


class WniosekMiejsceNaCmentarzu extends React.Component {

  state = {
    service_type: null,
    first_name: null,
    name: null,
    death_date: null,
    child_or_adult: null,
    extension_date: null,
    extension_period: null,
    extension_to: null,
    service_netto_cost: 0.00,

    teryt: null,

    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  };

  validators = {
    service_type: [v.NotSelected],
    first_name: [v.NotNull],
    name: [v.NotNull],
    death_date: [v.NotNull, v.CheckDate, v.MinLength(10), v.MaxLength(10)],
    extension_date: [v.NotNull, v.CheckDate, v.MinLength(10), v.MaxLength(10)],
    extension_period: [v.NotNull]
  };

  errorSpanStyle = {
    color: 'red',
    fontSize: '10px',
  };

  inputStyle = { borderRadius: '0' };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    // Pobieram teryt z linku i przypisuje do state
    const url_string = window.location.href;
    const url = new URL(url_string);
    const c = url.searchParams.get('district');

    this.setState({
      teryt: c,
    });
  }

  insertTestData = () => {
    this.setState({
      first_name: 'test first name',
      name: 'test name',
      death_date: '20-01-1990',
      child_or_adult: 'osoba dorosła',
      extension_date: '15-09-2019',
      extension_period: '5',
      service_type: 'Miejsce na grób przy pochowaniu na 20 lat'
    });
  };

  calculateCost() {
    let cost = 0.00;
    if (this.state.service_type == 'Rezerwacja miejsca na grób ziemny') {
      if (this.state.extension_period == '5') {
        cost = 150.00;
      }
      else {
        cost = 400.00;
      }
    }
    if (this.state.service_type == 'Miejsce na grób przy pochowaniu na 20 lat') {
      if (this.state.child_or_adult == 'osoba dorosła') {
        cost = 100.00;
      }
      else {
        cost = 40.00;
      }
    }
    if (this.state.service_type == 'Przedłużenie okresu pochowania na następne 20 lat') {
      if (this.state.child_or_adult == 'osoba dorosła') {
        cost = 300.00;
      }
      else {
        cost = 180.00;
      }
    }
    this.setState({
      service_netto_cost: cost.toFixed(2)
    });
  };

  handleChangeSelect = (e, name) => {
    this.setState({ [name]: e.value }, () => this.validate(name));
    if (name == 'service_type' && (e.value == 'Miejsce na grób przy pochowaniu na 20 lat' || e.value == 'Przedłużenie okresu pochowania na następne 20 lat')) {
      this.setState({ extension_period: '20' });
      this.validators['child_or_adult'] = [v.NotSelected];
    } else {
      this.validators['child_or_adult'] = [];
    }
  };

  calculateDate() {
    const oldDate = this.state.extension_date;
    if (oldDate && oldDate.length === 10) {
      let parts = oldDate.split("-");
      let yearsToAdd = null;
      if (this.state.service_type != 'Rezerwacja miejsca na grób ziemny') {
        yearsToAdd = 20;
      }
      else {
        if (this.state.extension_period) {
          yearsToAdd = parseInt(this.state.extension_period, 10);
        }

      }
      if (yearsToAdd) {
        const year = parseInt(parts[2], 10) + yearsToAdd;
        const newDate = parts[0] + '-' + parts[1] + '-' + year;
        this.setState({
          extension_to: newDate
        });
      }
      else {
        this.setState({
          extension_to: null
        });
      }
    }
    else {
      this.setState({
        extension_to: null
      });
    }

  };

  htmlDecode(input) {
    if (typeof window !== 'undefined') {
      const e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  };

  handleChange = (e, name) => {
    this.setState({ [name]: e.target.value, }, () => this.validate(name));
  };

  getSelectErrorStyle = (name_state) => {
    const selectErrorStyle = {
      borderColor:
        Object.keys(this.state.errors).indexOf(name_state) > -1 &&
          this.state.errors[name_state] !== null &&
          this.state.errors[name_state].length > 0
          ? 'red'
          : '#ccc',
    };
    return selectErrorStyle;
  }

  validateField = (field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[field]);
        if (check) checks.push(check);
      }
    }

    if (checks.length == 0 && (field == 'service_type' || field == 'extension_period' || field == 'child_or_adult' || field == 'extension_date')) {
      this.calculateDate();
    }
    return checks;
  };

  validate = (field, callback = null) => {
    let newState = null;
    if (field && Object.keys(this.validators).indexOf(field) > -1) {
      const checks = this.validateField(field);
      newState = {
        errors: {
          ...this.state.errors,
          [field]: checks,
        },
      };
    }
    else {
      let errors = { ...this.state.errors };
      for (const field of Object.keys(this.validators)) {
        const checks = this.validateField(field);
        errors = { ...errors, [field]: checks };
      }
      newState = {
        errors: {
          ...errors
        },
      };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
    if (field == 'service_type' || field == 'extension_period' || field == 'child_or_adult') {
      this.calculateCost();
    }
  };

  onHide = () => this.setState({ showError: false });

  onJobFinish = (resp) => {
    if (this.props.serviceInfo.user.userType === 'local') {
      window.location.href = `${this.nextStep}${resp.jobId}`;
    } else {
      window.location.href = `${this.nextStep}${resp.jobId}?customerId=${this.props.query.customerId}`;
    }
  };

  onJobFailed = () => this.setState({
    isWorking: false,
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
  });

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Formularz zawiera błędy.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors) {
      const tax = (0.08 * parseFloat(this.state.service_netto_cost)).toFixed(2);
      const brutto = (parseFloat(tax) + parseFloat(this.state.service_netto_cost)).toFixed(2);
      const data = {
        service_data: {
          first_name: this.state.first_name,
          name: this.state.name,
          death_date: this.state.death_date,
          child_or_adult: this.state.child_or_adult,
          service_type: this.state.service_type,
          extension_date: this.state.extension_date,
          extension_to: this.state.extension_to,
          service_netto_cost: this.state.service_netto_cost,
          tax: tax,
          brutto_cost: brutto,
          extension_period: this.state.extension_period,
          fk_userID: this.props.serviceInfo.user.ID,
          teryt: this.state.teryt
        },
        teryt: this.state.teryt,
        shortName: this.props.serviceInfo.eservice.shortName,
        user: { ...this.props.serviceInfo.user },
      };
      this.props
        .runService(this.props.serviceInfo.eservice.shortName,
          this.props.district,
          data)
        .then(resp => {
          this.onJobFinish(resp);
        });
    }
  };

  startService = () => {
    this.validate(null, this.postValidation);
  };

  render() {
    // layout classes
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-7';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };



    const optionsServiceType = [
      {
        label: 'Miejsce na grób przy pochowaniu na 20 lat',
        value: 'Miejsce na grób przy pochowaniu na 20 lat',
      },
      {
        label: 'Rezerwacja miejsca na grób ziemny',
        value: 'Rezerwacja miejsca na grób ziemny',
      },
      {
        label: 'Przedłużenie okresu pochowania na następne 20 lat',
        value: 'Przedłużenie okresu pochowania na następne 20 lat',
      },
    ];

    const optionsChildOrAdult = [
      {
        label: 'osoba dorosła',
        value: 'osoba dorosła',
      },
      {
        label: 'dziecko',
        value: 'dziecko',
      },
    ];

    const optionsOrderPeriod = [
      {
        label: '5',
        value: '5',
      },
      {
        label: '20',
        value: '20',
      },
    ];

    // dane zmarlego
    this.personData = [
      {
        label: 'Imię zmarłego', // Nazwa wyświetlana
        state: this.state.first_name, // Jaki state bedzie trzymal dane
        name_state: 'first_name', // Nazwa state'a zeby zmieniac
        placeholder: 'Imię zmarłego...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Nazwisko zmarłego', // Nazwa wyświetlana
        state: this.state.name, // Jaki state bedzie trzymal dane
        name_state: 'name', // Nazwa state'a zeby zmieniac
        placeholder: 'Nazwisko zmarłego...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Data śmierci (dd-mm-rrrr)', // Nazwa wyświetlana
        state: this.state.death_date, // Jaki state bedzie trzymal dane
        name_state: 'death_date', // Nazwa state'a zeby zmieniac
        placeholder: 'Data śmierci...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
    ];

    // dane przedluzenia
    this.orderData = [
      {
        label: 'Rodzaj usługi', // Nazwa wyświetlana
        state: this.state.service_type, // Jaki state bedzie trzymal dane
        name_state: 'service_type', // Nazwa state'a zeby zmieniac
        placeholder: 'Rodzaj usługi...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: optionsServiceType, // Tablica z wyborami,
      },
      {
        label: 'Przedłużenie od dnia (dd-mm-rrrr)', // Nazwa wyświetlana
        state: this.state.extension_date, // Jaki state bedzie trzymal dane
        name_state: 'extension_date', // Nazwa state'a zeby zmieniac
        placeholder: 'Wprowadź datę...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Przedłużenie do dnia (dd-mm-rrrr)', // Nazwa wyświetlana
        state: this.state.extension_to, // Jaki state bedzie trzymal dane
        name_state: 'extension_to', // Nazwa state'a zeby zmieniac
        placeholder: 'Data obliczana automatycznie...',
        type_input: 2, // 0 - zwykly input, 1 - React Select, 2 - input disabled
        options: 0, // Tablica z wyborami,
      },

      {
        label: 'Cena netto [zł]', // Nazwa wyświetlana
        state: this.state.service_netto_cost, // Jaki state bedzie trzymal dane
        name_state: 'service_netto_cost', // Nazwa state'a zeby zmieniac
        placeholder: 'Cena obliczana automatycznie...',
        type_input: 2, // 0 - zwykly input, 1 - React Select, 2 - input disabled
        options: 0, // Tablica z wyborami,
      },
    ];

    return (
      <div>
        <br />
        {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ? (
          <div>
            <h3 style={{ textAlign: 'center' }}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            <GrayPanel title="Dane osoby zmarłej">
              {this.personData.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />

                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}
              {this.state.service_type != 'Rezerwacja miejsca na grób ziemny' ? (
                <div className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle}>Dorosły/dziecko?</label>
                  </div>
                  <div className={inputCol}>
                    <Select
                      clearable={false}
                      options={optionsChildOrAdult}
                      value={this.state.child_or_adult}
                      placeholder={"Wybierz z listy..."}
                      onChange={e => this.handleChangeSelect(e, 'child_or_adult')}
                      style={this.getSelectErrorStyle('child_or_adult')}
                      onBlur={event => event.preventDefault()}
                      optionClassName="needsclick"
                      blurInputOnSelect={false}
                    />
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf('child_or_adult') > -1 &&
                      this.state.errors['child_or_adult'] !== null &&
                      this.state.errors['child_or_adult'].length > 0
                      ? this.state.errors['child_or_adult'].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ) : null}

            </GrayPanel>

            <GrayPanel title="Informacje dotyczące zamówienia">
              {this.orderData.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={this.getSelectErrorStyle(v.name_state)}
                        onBlur={event => event.preventDefault()}
                        optionClassName="needsclick"
                        blurInputOnSelect={false}
                      />
                    ) : null}
                    {v.type_input == 2 ? (
                      <input
                        className="form-control"
                        disabled
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}
              {this.state.service_type == 'Rezerwacja miejsca na grób ziemny' ? (
                <div className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle}>Okres rezerwacji (w latach)</label>
                  </div>
                  <div className={inputCol}>
                    <Select
                      clearable={false}
                      options={optionsOrderPeriod}
                      value={this.state.extension_period}
                      placeholder={"Wybierz z listy..."}
                      onChange={e => this.handleChangeSelect(e, 'extension_period')}
                      style={this.getSelectErrorStyle('extension_period')}
                      onBlur={event => event.preventDefault()}
                      optionClassName="needsclick"
                      blurInputOnSelect={false}
                    />
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf('extension_period') > -1 &&
                      this.state.errors['extension_period'] !== null &&
                      this.state.errors['extension_period'].length > 0
                      ? this.state.errors['extension_period'].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ) : null}
            </GrayPanel>
          </div>
        ) : null}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.startService()}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

WniosekMiejsceNaCmentarzu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WniosekMiejsceNaCmentarzu),
);


// WEBPACK FOOTER //
// src/routes/eservices/WniosekMiejsceNaCmentarzu.js